const env = {
  ID: "prod",
  API_URL: "https://survey.api.nexlabs.app",
  AUTH_API_URL: "https://authentication.api.nexlabs.app",
  GOOGLE_MAP_API_KEY: "AIzaSyDP_hYZ09oQs_8k7Ak9Y7uHjO-PDDbrWpM",
  RECAPTCHA_SITE_KEY: "6LfN594sAAAAADxStkyf5EJ-8JXLMh6YjRzyLQu6",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyBq2-YVQDyXRxYjDr-SjHX2E9uAw1m0FuI",
    authDomain: "dev-ms-auth.firebaseapp.com",
    projectId: "dev-ms-auth",
    appId: "1:855340801157:web:4fbefbfce8d0df8ff95dec",
  },
};

export default env;
